module.exports = __webpack_public_path__ + "fonts/AdelleSAGE-Bold.f36c4c98.woff";